import { render, staticRenderFns } from "./AlbumShareMenu.vue?vue&type=template&id=2a07ac56&scoped=true&"
import script from "./AlbumShareMenu.vue?vue&type=script&lang=js&"
export * from "./AlbumShareMenu.vue?vue&type=script&lang=js&"
import style0 from "./AlbumShareMenu.vue?vue&type=style&index=0&id=2a07ac56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a07ac56",
  null
  
)

export default component.exports